import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { Link } from "react-router-dom";
import "./index.css";

/* Components */
import Page from "../../components/Page";
import Login from "./components/Login";
import ResetPassword from "./components/ResetPassword";

class SignIn extends Component {

    handleView = (props) => {

        if (props.match.path.includes("/sign-in")) return <Login {...this.props} />;
        if (props.match.path.includes("/sign-up")) return <Login {...this.props} />;
        if (props.match.path.includes("/reset-password")) return <ResetPassword queryString={props.location.search} />;

    }

    render() {

        const isAuth = this.props.match.path === "/sign-in" || this.props.match.path === "/sign-up";

        return(
            <Page {...this.props} linear={true}>
                <div className="auth-page-main-container">
                    <div className="auth-page-main-wrapper">
                        <div className="auth-page-form-container">
                            {this.handleView(this.props)}
                        </div>
                        <div className="auth-page-image-container">
                            <div className="auth-page-image-wrapper">
                                <img src={require("../../assets/svgs/yacht.svg")} alt="" />
                            </div>
                            <div className="auth-page-image-title-container">
                                <span className="auth-page-image-title">Find Great Jobs</span>
                            </div>
                            {this.props.match.path === "/sign-up" &&
                                <div className="auth-page-image-subtitle-container margin-top-2x">
                                    <span className="auth-page-image-subtitle">Try us today!</span>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                {isAuth &&
                    <div className="auth-page-testimonial-section">
                        <p className="auth-page-testimonial-eyebrow">Trusted by yacht crew worldwide</p>
                        <div className="auth-page-testimonial-grid">
                            <div className="auth-page-testimonial-card">
                                <p className="auth-page-testimonial-quote">These guys are awesome! Really helpful! Got my first job through them. I will use them every time. One of the best for sure!</p>
                                <div className="auth-page-testimonial-attribution">
                                    <div className="auth-page-testimonial-avatar" style={{ background: "#1F3A66" }}>AS</div>
                                    <div>
                                        <p className="auth-page-testimonial-name">Alex Smith</p>
                                        <p className="auth-page-testimonial-role">Crew Member</p>
                                    </div>
                                </div>
                            </div>
                            <div className="auth-page-testimonial-card">
                                <p className="auth-page-testimonial-quote">No ridiculously long forms full of impersonal and irrelevant questions. Great service, always quick to respond. Would recommend to anyone in the yachting industry.</p>
                                <div className="auth-page-testimonial-attribution">
                                    <div className="auth-page-testimonial-avatar" style={{ background: "#FF5E33" }}>TP</div>
                                    <div>
                                        <p className="auth-page-testimonial-name">Tom Pearson</p>
                                        <p className="auth-page-testimonial-role">Crew Member</p>
                                    </div>
                                </div>
                            </div>
                            <div className="auth-page-testimonial-card">
                                <p className="auth-page-testimonial-quote">We have used J4Crew for over 10 years now and have always been 100% satisfied with the services provided.</p>
                                <div className="auth-page-testimonial-attribution">
                                    <div className="auth-page-testimonial-avatar" style={{ background: "#3E5383" }}>RS</div>
                                    <div>
                                        <p className="auth-page-testimonial-name">Rich Swansbury</p>
                                        <p className="auth-page-testimonial-role">Captain</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                <div className="web-page-footer-container">
                    <p>
                        <span>© {moment().year()} J4Crew</span>
                        <Link to={"/terms-and-conditions"}>Terms</Link>
                        <Link to={"/privacy-policy"}>Privacy</Link>
                        <Link to={"/contact-us"}>Contact</Link>
                        <Link to={"/about-us"}>About</Link>
                        <Link to={"/mlc-2006"}>MLC 2006</Link>
                    </p>
                </div>
            </Page>
        );

    }

}

const mapStateToProps = (state) => {
    return {
        user: state.user,
    }
}

export default connect(mapStateToProps)(SignIn);